<div class="container !overflow-hidden  px-[30px]  w-full    py-5 relative">
    <div class="w-full flex items-center justify-end">



    </div>
    <div class="flex w-full items-center justify-between overflow-x-hidden mt-10">
        <div class="flex w-1/2 justify-start items-center">
            <div class="flex items-center justify-start w-fit ">
                <h1
                    class="font-avantgarde text-4xl md:text-[50.23px] font-bold leading-[42.91px] md:leading-[59.87px] text-left text-[var(--quaternary)]">
                    Da
                </h1>
                <h1
                    class="font-avantgarde text-4xl md:text-[50.23px] font-normal leading-[43.15px] md:leading-[60.22px] text-left text-[var(--quaternary)]">
                    Pico
                </h1>
            </div>
            <div
                class="bg-[var(--quaternary)] w-fit h-[35px] lg:h-[48.84px] rounded-md shadow-custom flex justify-center items-center ml-2 lg:ml-4 px-[6px]">
                <div class=" ">
                    <h1 class="text-[var(--tertiary)] font-avantgarde text-[26px] leading-7 font-bold w-full ">
                        HR
                    </h1>
                </div>
            </div>
        </div>


    </div>

    <div
        class="p-[30px] mt-10 lg:p-[60px] mb-20  flex flex-col justify-start size-full bg-[var(--tertiary)] rounded-[30px] ombra-pad">

        <div class="mx-auto w-20 h-20 bg-[var(--primary)] rounded-full mt-[70 mb-5 flex place-content-center">
            <img height="50" width="50" src="../../../assets/xmark-solid.svg">
        </div>
        <div class="text-[26px] font-bold mb-10 text-center">Questionario non trovato</div>

    </div>


    
</div>
